import { render, staticRenderFns } from "./uiTf.vue?vue&type=template&id=4ebbea2e"
import script from "./uiTf.vue?vue&type=script&lang=js"
export * from "./uiTf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports